/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import type { Theme } from '@coursera/cds-core';

type Props = {
  leftImage: string;
  leftPartnerName: string;
  rightImage: string;
  rightPartnerName: string;
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
  `,
  divider: (theme: Theme) => css`
    background: ${theme.palette.gray[500]};
    height: 32px;
    width: 2px;
    margin: ${theme.spacing(0, 24)};
  `,
  image: (theme: Theme) => css`
    max-width: 100%;
    height: 36px;
    ${theme.breakpoints.down('sm')} {
      height: 30px;
    }
  `,
};

const HeroCoBrandingPartnerLogos = ({ leftImage, leftPartnerName, rightImage, rightPartnerName }: Props) => {
  return (
    <div css={styles.container}>
      <Imgix src={leftImage} alt={leftPartnerName} maxHeight={36} css={styles.image} />
      <div css={styles.divider} data-testid="hero-co-branding-divider" />
      <Imgix src={rightImage} alt={rightPartnerName} maxHeight={36} css={styles.image} />
    </div>
  );
};

export default HeroCoBrandingPartnerLogos;
